import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

/**
 * Compact mid-page CTA band. Same visual language as the final CTASection
 * (cobalt base + faint grid overlay) but slimmer, with a primary button and
 * a text link that smooth-scrolls to the How It Works section.
 */
export default function GulfNewswireMidCTA() {
  const scrollToHowItWorks = () =>
    document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="relative bg-cobalt overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />
      <Container className="relative py-10 lg:py-12 text-center">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white leading-tight mb-3 max-w-2xl mx-auto">
          Your announcement could be live across the Gulf today.
        </h2>
        <p className="text-white/80 text-sm lg:text-base max-w-xl mx-auto mb-7 leading-relaxed">
          Same-day submission. Distribution typically begins within 30 minutes of approval.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/register">
            <Button size="lg" className="bg-white hover:bg-white/90 text-cobalt font-medium px-8 py-5 text-base">
              Get Started <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
          <button
            type="button"
            onClick={scrollToHowItWorks}
            className="text-sm text-white/90 hover:text-white underline underline-offset-4 decoration-white/40 transition-colors"
          >
            See how it works
          </button>
        </div>
      </Container>
    </section>
  );
}